import { LANGUAGE_ENUM } from '@/shared'
import { getCurrentLanguage } from '@/i18next'

export const generateData = (paramValues = [], dictParams = [], dictValues = {}) => {
	const lang = getCurrentLanguage()

	return paramValues?.map((i, idx) => {
		let find = dictParams?.find(param => param?.code === i?.paramCode)

		let measure = {
			[LANGUAGE_ENUM.kz]: find?.measureKz,
			[LANGUAGE_ENUM.rus]: find?.measureRu,
		}

		let title = {
			[LANGUAGE_ENUM.kz]: find?.nameKz,
			[LANGUAGE_ENUM.rus]: find?.nameRu,
		}

		let employer_data = {
			numValue: i?.numValue,
			textValue: i?.textValue,
			fileValue: i?.fileValue,
		}

		let comp_data = {
			numValue: i?.compNumValue,
			textValue: i?.compTextValue,
			fileValue: i?.compFileValue,
		}

		let mio_data = {
			numValue: i?.mioNumValue,
			textValue: i?.mioTextValue,
			fileValue: i?.mioFileValue,
		}

		if (find?.dictCode) {
			let dict = dictValues?.[find?.dictCode]

			let employer_dict_value = dict?.find(val => val?.code === i?.dictValue)
			let comp_dict_value = dict?.find(val => val?.code === i?.compDictValue)
			let mio_dict_value = dict?.find(val => val?.code === i?.mioDictValue)

			let employer_value = {
				[LANGUAGE_ENUM.kz]: employer_dict_value?.nameKz,
				[LANGUAGE_ENUM.rus]: employer_dict_value?.nameRu,
			}

			let comp_value = {
				[LANGUAGE_ENUM.kz]: comp_dict_value?.nameKz,
				[LANGUAGE_ENUM.rus]: comp_dict_value?.nameRu,
			}

			let mio_value = {
				[LANGUAGE_ENUM.kz]: mio_dict_value?.nameKz,
				[LANGUAGE_ENUM.rus]: mio_dict_value?.nameRu,
			}

			employer_data = {
				...employer_data,
				dictValue: employer_value?.[lang],
			}

			comp_data = {
				...comp_data,
				dictValue: comp_value?.[lang],
			}

			mio_data = {
				...mio_data,
				dictValue: mio_value?.[lang],
			}
		}

		let employer_value = (employer_data?.numValue || employer_data?.textValue || employer_data?.dictValue)
		let mio_value = (mio_data?.numValue || mio_data?.textValue || mio_data?.dictValue)
		let comp_value = (comp_data?.numValue || comp_data?.textValue || comp_data?.dictValue)

		return {
			isEdit: !!i.mioComment,
			key: `${idx}-${i.paramCode}`,
			title: title[lang] || '-',
			employer_data: employer_value ? `${employer_value} ${measure[lang] || ''}` : '-',
			mio_data: mio_value ? `${mio_value} ${measure[lang] || ''}` : '-',
			comp_data: comp_value ? `${comp_value} ${measure[lang] || ''}` : '-',
			employer_file: employer_data?.fileValue,
			mio_file: mio_data?.fileValue,
			comp_file: comp_data?.fileValue,
			dict: find,
			orderNum: find?.orderNum,
			...i,
		}
	})
}